import React, {useState} from 'react';
import {Pressable, StyleSheet, View} from 'react-native';

import theme from '../../style/theme';
import Modal from '../ui-controls/Modal';
import Text from '../ui-controls/Text';
import Checkbox from '../ui-controls/web/CheckBox';

function DeleteAccountModal({cancelCallback, okCallback, open}) {
  const [isTermsAccepted, setTermsAccepted] = useState(false);

  const handleChange = () => setTermsAccepted(!isTermsAccepted);

  return (
    <Modal
      onBackdropPress={cancelCallback}
      isVisible={open}
      title="Are you sure that you want to delete your account?">
      <>
        <View style={styles.checkboxContainer}>
          <Checkbox
            boxType="square"
            checked={isTermsAccepted}
            onChange={handleChange}
            style={styles.checkbox}
            lineWidth={1}
          />
          <Text style={styles.label}>
            I accept the Terms &amp; Conditions (left menu, Information)
          </Text>
        </View>
        <View style={styles.buttonsContainer}>
          <Pressable
            onPress={okCallback}
            style={{
              ...styles.okButton,
              ...(isTermsAccepted ? styles.button : styles.disabledButton),
            }}
            disabled={!isTermsAccepted}>
            <Text style={styles.disabledButton.text}>{'YES, DELETE'}</Text>
          </Pressable>
          <Pressable onPress={cancelCallback} style={styles.button}>
            <Text style={styles.button.text}>{'CANCEL'}</Text>
          </Pressable>
        </View>
      </>
    </Modal>
  );
}

export default DeleteAccountModal;

const styles = StyleSheet.create({
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  okButton: {
    marginTop: 8,
    marginBottom: 8,
  },
  disabledButton: {
    borderColor: 'darkgray',
    backgroundColor: 'lightgrey',
    paddingVertical: 8,
    borderRadius: 4,
    paddingHorizontal: 16,
    alignItems: 'center',
    text: {
      color: 'white',
      fontWeight: '600',
    },
  },
  button: {
    backgroundColor: theme.colour.background.button.primary,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 4,
    alignItems: 'center',
    text: {
      color: 'white',
      fontWeight: '600',
    },
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkbox: {
    alignSelf: 'center',
  },
  label: {
    margin: 8,
  },
});
